export default {
  priority: 95,
  name: app.translate('routes.home.attendance.leave.Leave'),
  path: 'Leave',
  permissions: ['TimeAttendanceMenu/RemainingLeaveMenu'],
  icon: 'folder',
  drawer: true,
};


